import React from 'react';

export const IconArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M8 11L14 17L20 11" stroke="#000000" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const EyeIcon = (props) => (
  <svg
    className={'cursor-pointer'}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx="12" cy="12" r="3" stroke="#33363F" strokeWidth="1.2" />
    <path
      d="M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z"
      stroke="#33363F"
      strokeWidth="1.2"
    />
  </svg>
);
export const EyeInvisibleIcon = (props) => (
  <svg
    className={'cursor-pointer'}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx="12" cy="12" r="3" stroke="#33363F" strokeWidth="1.2" />
    <path
      d="M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z"
      stroke="#33363F"
      strokeWidth="1.2"
    />
    <path d="M5 5L20 18" stroke="#ffffff" strokeWidth="4" />
    <path d="M5 1L22 18" stroke="#33363F" strokeWidth="1.2" />
  </svg>
);

export const ClearIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 31" fill="none">
    <path
      opacity="0.2"
      d="M28.8765 15.5028C28.8765 8.45785 23.1654 2.74679 16.1205 2.74679C9.07556 2.74679 3.3645 8.45785 3.3645 15.5028C3.3645 22.5477 9.07556 28.2588 16.1205 28.2588C23.1654 28.2588 28.8765 22.5477 28.8765 15.5028Z"
      fill="#737373"
    />
    <path
      d="M16.1206 14.1508L13.1867 11.2169C12.8168 10.847 12.2045 10.847 11.8346 11.2169C11.4646 11.5869 11.4646 12.1991 11.8346 12.5691L14.7685 15.5029L11.8346 18.4368C11.4646 18.8068 11.4646 19.419 11.8346 19.789C12.2045 20.1589 12.8168 20.1589 13.1867 19.789L16.1206 16.8551L19.0545 19.789C19.4244 20.1589 20.0367 20.1589 20.4066 19.789C20.5979 19.5976 20.6872 19.3553 20.6872 19.1129C20.6872 18.8705 20.5979 18.6282 20.4066 18.4368L17.4727 15.5029L20.4066 12.5691C20.5979 12.3777 20.6872 12.1354 20.6872 11.893C20.6872 11.6506 20.5979 11.4083 20.4066 11.2169C20.0367 10.847 19.4244 10.847 19.0545 11.2169L16.1206 14.1508Z"
      fill="#737373"
    />
  </svg>
);

export const CertificateIcon = () => (
  <svg width="30px" height="30px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_iconCarrier">
      <path
        d="M9 10M12 3L13.9101 4.87147L16.5 4.20577L17.2184 6.78155L19.7942 7.5L19.1285 10.0899L21 12L19.1285 13.9101L19.7942 16.5L17.2184 17.2184L16.5 19.7942L13.9101 19.1285L12 21L10.0899 19.1285L7.5 19.7942L6.78155 17.2184L4.20577 16.5L4.87147 13.9101L3 12L4.87147 10.0899L4.20577 7.5L6.78155 6.78155L7.5 4.20577L10.0899 4.87147L12 3Z"
        fill="#93c5fd"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.5 L11.2 15.4 L15.5 8.7"
        stroke="#ffffff"
        strokeWidth="1.38"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const LogoutIcon = ({ color = 'white' }) => (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.83301 0.888672C2.16997 0.888672 1.53408 1.15206 1.06524 1.6209C0.5964 2.08975 0.333008 2.72563 0.333008 3.38867V15.0553C0.333008 15.7184 0.5964 16.3543 1.06524 16.8231C1.53408 17.2919 2.16997 17.5553 2.83301 17.5553H11.1663C11.8294 17.5553 12.4653 17.2919 12.9341 16.8231C13.4029 16.3543 13.6663 15.7184 13.6663 15.0553V14.222C13.6663 13.7618 13.2932 13.3887 12.833 13.3887C12.3728 13.3887 11.9997 13.7618 11.9997 14.222V15.0553C11.9997 15.2764 11.9119 15.4883 11.7556 15.6446C11.5993 15.8009 11.3874 15.8887 11.1663 15.8887H2.83301C2.61199 15.8887 2.40003 15.8009 2.24375 15.6446C2.08747 15.4883 1.99967 15.2764 1.99967 15.0553V3.38867C1.99967 3.16766 2.08747 2.9557 2.24375 2.79942C2.40003 2.64314 2.61199 2.55534 2.83301 2.55534H11.1663C11.3874 2.55534 11.5993 2.64314 11.7556 2.79942C11.9119 2.9557 11.9997 3.16766 11.9997 3.38867V4.22201C11.9997 4.68224 12.3728 5.05534 12.833 5.05534C13.2932 5.05534 13.6663 4.68224 13.6663 4.22201V3.38867C13.6663 2.72563 13.4029 2.08975 12.9341 1.6209C12.4653 1.15206 11.8294 0.888672 11.1663 0.888672H2.83301Z"
      fill={color}
    />
    <path
      d="M10.9223 6.13275C10.5968 5.80731 10.0692 5.80731 9.74375 6.13275C9.41831 6.45819 9.41831 6.98582 9.74375 7.31126L10.8212 8.38867H6.99967C6.53944 8.38867 6.16634 8.76177 6.16634 9.222C6.16634 9.68224 6.53944 10.0553 6.99967 10.0553H10.8212L9.74375 11.1327C9.41831 11.4582 9.41831 11.9858 9.74375 12.3113C10.0692 12.6367 10.5968 12.6367 10.9223 12.3113L13.4223 9.81126C13.7477 9.48582 13.7477 8.95819 13.4223 8.63275L10.9223 6.13275Z"
      fill={color}
    />
  </svg>
);
